import { NavLogo } from './NavbarElements'
import { CgFormatRight } from "react-icons/cg";
import { Link } from 'react-scroll'
import './Navbar.css'

const index = ({ toggle }) => {
  return (
    <div className='Nav'>
        <div className='NavbarContainer'>
            <NavLogo to='/'>
                <div className='Navlogo' />
            </NavLogo>
             <div className='MobileIcon' onClick={toggle}>
                    <CgFormatRight />
            </div>
            
            <ul className='nav-links'>
                <li>
                    <NavLogo to='/catering'>
                        Catering
                    </NavLogo>
                    <ul className='dropdown'>
                        <li><NavLogo to='/catering'>Buffér</NavLogo></li>
                        <li><NavLogo to='/breakfast'>Frukost</NavLogo></li>
                        <li><NavLogo to='/lunch'>Lunch</NavLogo></li>
                    </ul>
                </li>
                <li>
                    <NavLogo to='/event'>
                        Eventlokaler
                    </NavLogo>
                </li>
                <li>
                    <Link to='services' smooth={true} duration={2000} offset={50} className='NavLinks'>
                        Tjänster
                    </Link>
                    <ul className='dropdown'>
                        <li><NavLogo to='/catering'>Catering</NavLogo></li>
                        <li><NavLogo to='/event'>Eventlokaler</NavLogo></li>
                        <li><NavLogo to='/wedding'>Bröllop</NavLogo></li>
                        <li><NavLogo to='/decore'>Decor</NavLogo></li>
                        <li><NavLogo to='/service'>Service</NavLogo></li>
                        <li><NavLogo to='/cars'>Bilar</NavLogo></li>
                    </ul>
                </li>
                
                <li><a href='#'>Kontakta oss</a>
                    <ul className='dropdown'>
                        <li><NavLogo to='/about'>Om oss</NavLogo></li>
                        <li>
                            <a href='tel:0764130853'>
                                076 413 08 53
                            </a>
                        </li>
						<li>
                            <a href="mailto:cateringbyprestig@gmail.com">
								cateringbyprestig@gmail.com
							</a>
						</li>
                        <li><NavLogo to='/consultant'>Kostnadsfri konsultation</NavLogo></li>
                    </ul>
                </li>
                 <li>
                    <Link to='contact' smooth={true} duration={2800} offset={50} className='NavLinks'>
                        <a href='#'>Gör en förfrågan</a>
                    </Link>
                </li>
            </ul>
        </div>
    </div>
  )
}

export default index